import React from "react";

interface ProviderBadgeProps {
  provider?: string;
}

export const ProviderBadge: React.FC<ProviderBadgeProps> = ({
  provider = "N/A",
}) => {
  if (!provider || provider === "N/A") {
    return <span className="text-[13px] font-normal text-[#667085]">N/A</span>;
  }

  return (
    <div className="flex items-center gap-2 text-[13px] font-normal text-[#344054]">
      {/* Providus stylized leaf/shield icon */}
      <div className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#EBE4FF]">
        <svg
          width="13"
          height="13"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 16.5V13H7.5C6.67 13 6 12.33 6 11.5C6 10.67 6.67 10 7.5 10H11V6.5C11 5.67 11.67 5 12.5 5C13.33 5 14 5.67 14 6.5V10H17.5C18.33 10 19 10.67 19 11.5C19 12.33 18.33 13 17.5 13H14V16.5C14 17.33 13.33 18 12.5 18C11.67 18 11 17.33 11 16.5Z"
            fill="#6F00FF"
          />
        </svg>
      </div>
      <span className="truncate">{provider}</span>
    </div>
  );
};
